import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CheckIcon from './svg/CheckIcon';

import './SubmitButton.scss';

class SubmitButton extends Component {

    static propTypes = {
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool.isRequired,
        onClickAction: PropTypes.func.isRequired,
        successResult: PropTypes.bool,
        formRef: PropTypes.string,
        btnClass: PropTypes.string,
    }

    state = {
        btnStatus: ''
    }

    componentDidUpdate(prevProps, prevState) {
        let btnStatus = prevState.btnStatus;
        if (this.props.successResult === true) {
            btnStatus = 'checked';
        } else if (this.props.successResult === false) {
            btnStatus = 'failed';
        }

        if(btnStatus !== prevState.btnStatus) {
            //ok to use setState here as wrapped in a condition 
            this.setState({ btnStatus });  //eslint-disable-line react/no-did-update-set-state
        }
    }

    handleOnClick = (event) => {
        event.preventDefault();
        if (this.state.btnStatus === '') {
            this.setState({ btnStatus: 'loading'});
        }
        this.props.onClickAction();
    }

    render() {
        const { formRef = '', btnClass = 'submit-btn-default' } = this.props;
        return (
            <button 
                disabled={this.props.disabled} 
                className={`submit-btn ${btnClass} ${this.state.btnStatus}`} 
                onClick={this.handleOnClick}
                type="submit"
                form={formRef}
            >
                {this.props.label}
                <span>.</span><span>.</span><span>.</span>
                <CheckIcon title={`Successful ${this.props.label}`}/>
            </button>
        )
    }
}

export default SubmitButton;



// WEBPACK FOOTER //
// ./modules/Common/components/SubmitButton.js